"use strict";

exports.__esModule = true;

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Status = (_temp = _class = function Status() {
  _classCallCheck(this, Status);
}, _class.SUCCESS = 200, _class.CREATED = 201, _class.CONFLICT = 409, _class.INVALID = 400, _class.NOT_AUTHORIZED = 401, _class.FORBIDDEN = 403, _class.NOT_FOUND = 404, _class.isSuccess = function (statusCode) {
  if (statusCode === Status.SUCCESS || statusCode === Status.CREATED) {
    return true;
  }
  return false;
}, _class.isConflict = function (statusCode) {
  if (statusCode === Status.CONFLICT) {
    return true;
  }
  return false;
}, _class.isInvalid = function (statusCode) {
  if (statusCode === Status.INVALID) {
    return true;
  }
  return false;
}, _class.isNotAuthorized = function (statusCode) {
  if (statusCode === Status.NOT_AUTHORIZED) {
    return true;
  }
  return false;
}, _class.isForbidden = function (statusCode) {
  if (statusCode === Status.FORBIDDEN) {
    return true;
  }
  return false;
}, _class.isNotFound = function (statusCode) {
  if (statusCode === Status.NOT_FOUND) {
    return true;
  }
  return false;
}, _temp);
exports.default = Status;
module.exports = exports["default"];